import { Icon } from '@/app_components/common/Icon';
import type { ParserProps } from '@/app_lib/htmlParser/types';
import { type DOMNode, type DomElement, isElement, isText } from '@/app_lib/htmlParser/types';

const getTextContent = (node: unknown): string => {
  if (!node || typeof node !== 'object') {
    return '';
  }
  if (isText(node as DOMNode)) {
    return (node as { data?: string }).data ?? '';
  }
  if (isElement(node as DOMNode)) {
    const el = node as DomElement;
    if (el.children?.length) {
      return el.children.map((child) => getTextContent(child)).join('');
    }
  }
  return '';
};

const getListTextsFromColumn = (column: DomElement): string[] => {
  const ul = column.children?.find(
    (node): node is DomElement =>
      isElement(node as DOMNode) &&
      (node as DomElement).name === 'ul' &&
      (node as DomElement).attribs?.class?.includes('fortune-proscons-list'),
  );
  if (!ul?.children) {
    return [];
  }
  return ul.children
    .filter((node): node is DomElement => isElement(node as DOMNode) && (node as DomElement).name === 'li')
    .map((li) => getTextContent(li).trim())
    .filter(Boolean);
};

export const ProsCons = ({ domNode }: ParserProps) => {
  const columns = (domNode.children ?? []).filter(
    (node): node is DomElement =>
      isElement(node as DOMNode) && (node as DomElement).attribs?.class?.includes('fortune-proscons-column'),
  );
  const pros = columns[0] ? getListTextsFromColumn(columns[0]) : [];
  const cons = columns[1] ? getListTextsFromColumn(columns[1]) : [];

  return (
    <div className='grid layout-grid-gap md:grid-cols-2 md:grid-rows-1'>
      <div className='flex flex-col gap-sm row-start-1 md:col-start-1'>
        <div className='flex items-center gap-sm [&_span]:text-primary font-medium'>
          <Icon
            className='text-[var(--color-green-500)]'
            icon='CircleCheck'
            size='sm'
          />
          <span className='typography-xs font-graphik!'>PROS</span>
        </div>
        <ul className='text-secondary [&_li::marker]:text-secondary flex flex-col gap-sm '>
          {pros.map((pro) => (
            <li key={pro}>{pro}</li>
          ))}
        </ul>
      </div>

      <div className='flex flex-col gap-sm row-start-2 md:row-start-1 md:col-start-2'>
        <div className='flex items-center gap-sm [&_span]:text-primary font-medium'>
          <Icon
            className='icon-red'
            icon='CircleX'
            mode='custom'
            size='sm'
          />
          <span className='typography-xs font-graphik!'>CONS</span>
        </div>
        <ul className='text-secondary [&_li::marker]:text-secondary flex flex-col gap-sm '>
          {cons.map((con) => (
            <li key={con}>{con}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
